var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReferralOmega(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M36 66C52.5685 66 66 52.5685 66 36C66 19.4315 52.5685 6 36 6C19.4315 6 6 19.4315 6 36C6 52.5685 19.4315 66 36 66Z",
    fill: "#C7D7F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M51 51.75H41.7001C40.8001 51.75 39.9901 51.24 39.6301 50.4C39.2701 49.56 39.4201 48.63 40.0201 47.97L44.8801 42.6C46.8901 40.35 48.03 37.5001 48.03 34.5601C48.03 31.5601 46.7999 28.74 44.5499 26.61C42.2999 24.48 39.18 23.25 36 23.25C32.82 23.25 29.7001 24.48 27.4501 26.61C25.2001 28.74 23.97 31.5601 23.97 34.5601C23.97 37.5001 25.0799 40.35 27.1199 42.6L31.9799 47.97C32.5799 48.63 32.7299 49.59 32.3699 50.4C32.0099 51.21 31.1999 51.75 30.2999 51.75H21C19.77 51.75 18.75 50.73 18.75 49.5C18.75 48.27 19.77 47.25 21 47.25H25.2299L23.7599 45.6301C20.9999 42.5701 19.47 38.6401 19.47 34.5601C19.47 30.3901 21.24 26.2801 24.36 23.3401C27.48 20.3701 31.62 18.75 36 18.75C40.38 18.75 44.52 20.3701 47.64 23.3401C50.73 26.2801 52.53 30.3901 52.53 34.5601C52.53 38.6101 51 42.5401 48.2401 45.6301L46.7701 47.25H51C52.23 47.25 53.25 48.27 53.25 49.5C53.25 50.73 52.23 51.75 51 51.75Z",
    fill: "#437ADB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralOmega);
export default __webpack_public_path__ + "static/media/referral-omega.6bd7d5201e887639a7ac25410add1640.svg";
export { ForwardRef as ReactComponent };